export const SEND_EMAIL_NOTIFICATION = "SEND_EMAIL_NOTIFICATION"
export const SEND_EMAIL_NOTIFICATION_SUCCESS = "SEND_EMAIL_NOTIFICATION_SUCCESS"
export const SEND_EMAIL_NOTIFICATION_FAIL = "SEND_EMAIL_NOTIFICATION_FAIL"
export const CLEAR_SEND_EMAIL_NOTIFICATION = "CLEAR_SEND_EMAIL_NOTIFICATION"

export const SEND_SCORECARD_CREATION_REMINDER = "SEND_SCORECARD_CREATION_REMINDER"
export const SEND_SCORECARD_CREATION_REMINDER_SUCCESS = "SEND_SCORECARD_CREATION_REMINDER_SUCCESS"
export const SEND_SCORECARD_CREATION_REMINDER_FAIL = "SEND_SCORECARD_CREATION_REMINDER_FAIL"
export const CLEAR_SEND_SCORECARD_CREATION_REMINDER = "CLEAR_SEND_SCORECARD_CREATION_REMINDER"